import { handleResponseError } from "Infrastructure/Api/ApiUtils";
import {
	MutationCache,
	QueryCache,
	type QueryClientConfig,
} from "@tanstack/react-query";

export const queryClientConfig: QueryClientConfig = {
	queryCache: new QueryCache({
		onError: handleResponseError,
	}),
	mutationCache: new MutationCache({
		onError: handleResponseError,
	}),
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
};
